import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { toastError, toastSuccess } from "../../Components/ToastNotification";
import CardHeader from "../../Components/CardHeader";
import { faArrowLeft, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { addUserType } from "../../services/usertypeApi";
import { getjwt } from "../../services/authServices";
import { useNavigate } from "react-router-dom";

const headerButtons = [
  { buttonTitle: "Back", buttonUrl: "../usertypes", icon: faArrowLeft },
];

const INITIAL_DATA = {
  user_type: "",
  status: 1,
};

const Validater = (value) => {
  const errors = {};
  if (!value["user_type"]) {
    errors.user_type = "usertype is required";
  }
  return errors;
};

function UsertypeAdd() {
  const navgate = useNavigate();
  const [data, setData] = useState(INITIAL_DATA);
  const [formErrors, setformErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    let inputs = {
      ...data,
      [name]: value,
    };
    setData({ ...data, [name]: value });
    setformErrors(Validater(inputs));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = getjwt();
    if (data.user_type !== "") {
      data["token_data"] = JSON.parse(token);
      addUserType(data)
        .then((res) => {
          if (res.status === 201) {
            toastSuccess("Successfully created usertype");
            navgate("../usertypes");
          }
        })
        .catch((err) => {
          if (err.response) {
            err.response.data.errors.map((errors) =>
              toastError(`Failed : ${errors.error}`)
            );
          }
        });
    } else {
      setformErrors(Validater(data));
    }
  };

  return (
    <div className="container-fluid">
      <CardHeader headerItems={headerButtons} title="ADD USERTYPE" />
      <Card className="mb-3 border-0 shadow-sm rounded-2">
        <Card.Body>
          <div className="form-wrapper">
            <Form noValidate onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label className="fw-600">Usertype</Form.Label>
                  <Form.Control
                    type="text"
                    name="user_type"
                    placeholder="Enter the Usertype"
                    onChange={handleChange}
                    value={data.user_type}
                    className="border-2"
                    isInvalid={formErrors.user_type}
                  />
                  {formErrors.user_type && (
                    <Form.Control.Feedback type="invalid">
                      {formErrors.user_type}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Row>
              <Form.Control
                type="hidden"
                name="status"
                onChange={handleChange}
                value={1}
              />
              <Button
                variant="primary"
                type="submit"
                className="shadow rounded-5 mt-4"
              >
                <FontAwesomeIcon icon={faCircleCheck} /> Create usertype
              </Button>
            </Form>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default UsertypeAdd;
